import { render, staticRenderFns } from "./sale-order-multiselect-ajax.vue?vue&type=template&id=2a70e306&scoped=true&"
import script from "./sale-order-multiselect-ajax.vue?vue&type=script&lang=js&"
export * from "./sale-order-multiselect-ajax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a70e306",
  null
  
)

export default component.exports